import React from 'react';
import { Typography, Spin, message } from 'antd';
import { useQuery, gql, useMutation } from '@apollo/client';
import { useParams } from 'react-router';
import RoleForm from './RoleForm';
import {
  getScopesForInitialValues,
  scopesWithLevel,
  scopesWithNoLevel,
} from '../../../utils/scopes';
import {
  UPDATE_OVERRIDDEN_SCOPES_BY_ROLE,
  GET_OVERRIDDEN_SCOPES_BY_ROLE,
} from '../../../gql/projectCategories';

const GET_EDITING_OVERRIDDEN_SCOPES_BY_ROLE = gql`
  query overriddenScopesByRole($id: ID!) {
    overriddenScopesByRole(ids: [$id]) {
      id
      role {
        id
        name
      }
      scopes {
        type
        level
      }
    }
  }
`;

const { Text } = Typography;

const TabRolesEdit = () => {
  const { overriddenScopeId, id } = useParams();

  const { data, loading } = useQuery(GET_EDITING_OVERRIDDEN_SCOPES_BY_ROLE, {
    variables: { id: overriddenScopeId },
  });
  const [updateRole, { loading: mutationLoading }] = useMutation(
    UPDATE_OVERRIDDEN_SCOPES_BY_ROLE,
    {
      refetchQueries: [
        {
          query: GET_OVERRIDDEN_SCOPES_BY_ROLE,
          variables: { ids: [id], state: 'ALL' },
        },
      ],
      onCompleted: ({ updateOverriddenScopesByRoleInProjectCategory }) => {
        message.success(
          `Overriden scope in ${updateOverriddenScopesByRoleInProjectCategory.name} successfully edited`
        );
      },
      onError: (err) => {
        console.log(err);
      },
    }
  );

  return (
    !loading && (
      <>
        <Text
          type="secondary"
          style={{ display: 'block', paddingBottom: '16px' }}
        >
          Edit override the access right of roles in the project category
        </Text>
        <Spin spinning={mutationLoading} tip="Adding...">
          <RoleForm
            initialValues={{
              role: data.overriddenScopesByRole[0].role.id,
              ...getScopesForInitialValues(
                data.overriddenScopesByRole[0].scopes
              ),
            }}
            onFinish={(input) => {
              const getScopesFromInput = (scopes) => [
                ...scopesWithNoLevel(scopes),
                ...scopesWithLevel(scopes),
              ];
              const scopes = getScopesFromInput(input);
              console.log(scopes);
              updateRole({
                variables: {
                  input: {
                    id: overriddenScopeId,
                    role: input.role,
                    scopes,
                  },
                },
              });
            }}
          />
        </Spin>
      </>
    )
  );
};

export default TabRolesEdit;
